module.exports = __webpack_public_path__ + "static/how-to-do-nothing-670687d467a723430bac733e356af738.jpg";